export const _en = {
    id: {
        label: "Id"
    },
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    capacity: {
        label: "Has a capacity of (number of seats)"
    },
    isHuman: {
        label: "Is of human type"
    }
};

export const _fr = {
    id: {
        label: "Identifiant"
    },
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    capacity: {
        label: "Possède une capacité (nombre de places)"
    },
    isHuman: {
        label: "Est une catégorie humaine"
    }
};